import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";

const BreederCTASection = ({ user, login }) => {
  const navigate = useNavigate();

  const handleStartListing = () => {
    if (!user) {
      navigate('/signin?returnUrl=/subscription-plans');
    } else if (!user.roles?.includes('breeder')) {
      navigate('/subscription-plans');
    } else {
      navigate('/dashboard/breeder/new-listing');
    }
  };

  return (
    <section className="py-24 px-6 md:px-12 bg-[#0A0A0A]">
      <div className="max-w-4xl mx-auto text-center">
        <p className="text-xs tracking-[0.3em] uppercase text-[#D4AF37] mb-4">For Breeders</p>
        <h2 className="text-4xl md:text-5xl tracking-tight text-[#EDEDED] mb-6">List on Breedling</h2>
        <p className="text-lg text-[#A1A1AA] mb-8 max-w-2xl mx-auto">
          Join the premier marketplace for verified breeders. Reach qualified buyers, protect your transactions, and grow your reputation.
        </p>
        <button onClick={handleStartListing} className="btn-gold inline-flex items-center gap-2">
          {user ? 'Start Listing' : 'Sign In to Get Started'} <ArrowRight className="w-4 h-4" />
        </button>
      </div>
    </section>
  );
};

export default BreederCTASection;
